import axios from "axios";
import home from "../../home/home";
import {calculateTimeDifferenceTwoDates, geDataFormat, logOut} from "../../../common/utils";
import jwt_decode from "jwt-decode";
import TipologiaSanzione from '../../../common/mookup/tipologieSanzioni.json'

export default class dashboardTipoDocumentoService{



    getTipoDocumento(onSuccess,onError) {
      var objUser = JSON.parse(sessionStorage.getItem("user"));
      var decoded = jwt_decode(objUser.token);
      let host = process.env.REACT_APP_API_URL;
      const configHeaders = {
        headers: {
          Authorization: "Bearer " + objUser.token,
          CF: decoded.CFA,
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Headers":
            "Origin, X-Requested-With, Content-Type, Accept",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        }
      };
     axios.get(host+"/api/v1/tipoDocumento", configHeaders).then(function(result){
      if(result.status === 401){
        logOut();
      }
          onSuccess(result.data);
      }, function(error){
       if(error.response.status === 401){
          logOut();
        }
          console.log("Errore di  "+error);
            onError();
      });
    }


    deleteTipoDocumento(idDocumento,onSuccess,onError) {
      var objUser = JSON.parse(sessionStorage.getItem("user"));
      var decoded = jwt_decode(objUser.token);
      let host = process.env.REACT_APP_API_URL;
      const configHeaders = {
        headers: {
          Authorization: "Bearer " + objUser.token,
          CF: decoded.CFA,
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Headers":
            "Origin, X-Requested-With, Content-Type, Accept",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        }
      };
     axios.post(host+"/api/v1/tipoDocumento/disabilita/" + idDocumento,{}, configHeaders).then(function(result){
      if(result.status === 401){
        logOut();
      }
          onSuccess(result);
      }, function(error){
        if(error.response.status === 401){
          logOut();
        }
        onError();
      });
    }

    editTipoDocumento(tipoDocumento,onSuccess,onError) {
      var objUser = JSON.parse(sessionStorage.getItem("user"));
      var decoded = jwt_decode(objUser.token);
      let host = process.env.REACT_APP_API_URL;
      const configHeaders = {
        headers: {
          Authorization: "Bearer " + objUser.token,
          CF: decoded.CFA,
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Headers":
            "Origin, X-Requested-With, Content-Type, Accept",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        }
      };
     axios.patch(host+"/api/v1/tipoDocumento",tipoDocumento, configHeaders).then(function(result){
      if(result.status === 401){
        logOut();
      }
          onSuccess(result);
      }, function(error){
        if(error.response.status === 401){
          logOut();
        }
          console.log("Errore di  "+error);
          onError();
      });
    }
    createTipoDocumento(newDocumento,onSuccess,onError) {
      var objUser = JSON.parse(sessionStorage.getItem("user"));
      var decoded = jwt_decode(objUser.token);
      let host = process.env.REACT_APP_API_URL;
      const configHeaders = {
        headers: {
          Authorization: "Bearer " + objUser.token,
          CF: decoded.CFA,
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Headers":
            "Origin, X-Requested-With, Content-Type, Accept",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        }
      };
     axios.post(host+"/api/v1/tipoDocumento", newDocumento, configHeaders).then(function(result){
      if(result.status === 401){
        logOut();
      }
          onSuccess(result);
      }, function(error){
        if(error.response.status === 401){
          logOut();
        }
          console.log("Errore di  "+error);
          onError();
      });
    }

}
